import { FMSLeadAddToAbandonedCartSequenceStrategy, LocationVarKey } from "@swivl-mono/types";

import { WorksheetColumn, WorksheetRow } from "../../../Components/Worksheets/Layout/Worksheet.Layout.Components";
import { IS_NOT_EQUAL, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  QuestDropdownRow,
  SectionHeader,
  SwitchRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.OnboardingDocument,
  LocationVarKey.whichTier,
  LocationVarKey.SubscriptionMaxUsers,
  LocationVarKey.AgentAssistEnabled,
  LocationVarKey.SubscriptionEscalationSummary,
  LocationVarKey.HasReviewManager,
  LocationVarKey.HasSMSCampaigns,
  LocationVarKey.swivlHasVoice,
  LocationVarKey.S3AnalyticsDir,
  LocationVarKey.SpotBrandSlug,
  LocationVarKey.BrandImage,
  LocationVarKey.BrandColor,
  LocationVarKey.Persona,
  LocationVarKey.WebsiteProvider,
  { key: LocationVarKey.StoragelyClientID, hideIf: IS_NOT_EQUAL(LocationVarKey.WebsiteProvider, "storagely") },
  { key: LocationVarKey.StoragePugSingleLocationBaseURL, hideIf: IS_NOT_EQUAL(LocationVarKey.WebsiteProvider, "storagepug") },
  LocationVarKey.WantsNewChatNotifications,
  LocationVarKey.LeadEnableDuplicates,
  LocationVarKey.TwoUnhandledBeforeEscalation,
  LocationVarKey.WantsProfanityEscalation,
  LocationVarKey.HasSingleLocation,
  LocationVarKey.WantsOneMenuView,
  LocationVarKey.WantsClearStoreVariables,
  LocationVarKey.ShowSizeDescriptions,
  LocationVarKey.dontUseURLToSetStore,
  LocationVarKey.VarySettings,
  { key: LocationVarKey.VariesLoginURL, hideIf: IS_NOT_EQUAL(LocationVarKey.VarySettings, "1") },
  { key: LocationVarKey.VariesPayOnlineURL, hideIf: IS_NOT_EQUAL(LocationVarKey.VarySettings, "1") },
  { key: LocationVarKey.VariesSizeVisualsURL, hideIf: IS_NOT_EQUAL(LocationVarKey.VarySettings, "1") },
  LocationVarKey.LeadUnitId,
  LocationVarKey.OnlyShowUnitDimensions,
  LocationVarKey.GSGettingStartedCompleted,
  LocationVarKey.GSKickOffMilestoneCompleted,
  LocationVarKey.GSMilestone1Completed,
  LocationVarKey.GSMilestone2Completed,
  LocationVarKey.GSPostLaunchCompleted,
  LocationVarKey.AfterNavigateSizeVisualsQuestSlug,
  LocationVarKey.AfterNavigateShowInventoryQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginAutopayQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginPayBillQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginPasswordQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginUsernameQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginCreateLoginQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginCreditDebitQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginReservationsQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginUpdateBillingQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginUpdateContactQuestSlug,
  LocationVarKey.AfterNavigateCareersQuestSlug,
  LocationVarKey.AfterNavigateInsuranceQuestSlug,
  LocationVarKey.AfterNavigateAuctionQuestSlug,
  LocationVarKey.AfterNavigateReferralQuestSlug,
  LocationVarKey.AfterNavigateAccountLoginCancelServiceQuestSlug,
  LocationVarKey.AfterNavigateSMSShowInventoryQuestSlug,
  LocationVarKey.AfterNavigateSMSPayBillQuestSlug,
  LocationVarKey.AfterNavigateSMSAuctionQuestSlug,
  LocationVarKey.AfterNavigateSMSSizeVisualsQuestSlug,
  LocationVarKey.AfterNavigateSMSReferralQuestSlug,
  LocationVarKey.AfterNavigateSMSCareerQuestSlug,
  LocationVarKey.AfterNavigateSMSInsuranceQuestSlug,
  LocationVarKey.AfterNavigateSMSAboutQuestSlug,
  LocationVarKey.AfterNavigateSMSCreditDebitQuestSlug,
  LocationVarKey.AfterNavigateSMSAutoPayQuestSlug,
  LocationVarKey.AfterNavigateSMSPasswordQuestSlug,
  LocationVarKey.AfterNavigateSMSUpdateBillingQuestSlug,
  LocationVarKey.AfterNavigateSMSCreateLoginQuestSlug,
  LocationVarKey.AfterNavigateSMSUsernameQuestSlug,
  LocationVarKey.AfterNavigateSMSReservationsQuestSlug,
  LocationVarKey.AfterNavigateSMSAccountPayBillQuestSlug,
  LocationVarKey.AfterNavigateSMSUpdateContactQuestSlug,
  LocationVarKey.AfterNavigateSMSAccountLoginQuestSlug,
  LocationVarKey.AfterNavigateSMSSelectStoreQuestSlug,
  LocationVarKey.AfterNavigateSMSAccountLoginCancelServiceQuestSlug,
  LocationVarKey.SpotAccessCodeQuestSlug,
  LocationVarKey.SpotReviewQuestSlug,
  LocationVarKey.SpotPayBillOnlineQuestSlug,
  LocationVarKey.SpotPayBillPhoneQuestSlug,
  LocationVarKey.SpotManageAccountQuestSlug,
  LocationVarKey.LLMAIStorageConsultant,
  LocationVarKey.LLMAICustomerSupportRep,
  LocationVarKey.LLMisSizing,
  LocationVarKey.LLMisStoreSpecific,
  LocationVarKey.LLMisUnhandled,
  LocationVarKey.LLMisSuggestingPostalCode,
  LocationVarKey.LLMisAccess,
  LocationVarKey.LLMisAccountManagement,
  LocationVarKey.LLMisFeatures,
  LocationVarKey.LLMisIssueResolution,
  LocationVarKey.LLMisLease,
  LocationVarKey.LLMisPricing,
  LocationVarKey.LLMisInventory,
  LocationVarKey.LLMHasABTestAgents,
  { key: LocationVarKey.LLMAccessAfterHours, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1") },
  { key: LocationVarKey.LLMAccessGateCode, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1") },
  { key: LocationVarKey.LLMAccessKey, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1") },
  { key: LocationVarKey.LLMAccessPadlock, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1") },
  { key: LocationVarKey.LLMMoveTour, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1") },
  { key: LocationVarKey.LLMAccessUnitNumber, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1") },
  { key: LocationVarKey.LLMAccessAccountPastDue, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1") },
  { key: LocationVarKey.LLMAccessAccountInactive, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1") },
  { key: LocationVarKey.LLMAccountAccountBalance, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountAccountNumber, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountAutopay, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountBillingDispute, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountCancelService, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountChangeDueDate, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountCreateLogin, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountForgotUsername, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountGetLease, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountGracePeriod, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountHoldUnit, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountManageInsurance, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountMultipleAccounts, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountPartialPayment, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountPastDue, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountPayBill, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountPaymentExtension, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountPaymentHistory, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountPaymentIssue, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountReservations, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountResetPassword, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountUnitSize, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountUpdateBillingInfo, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMAccountUpdateContactInfo, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1") },
  { key: LocationVarKey.LLMFeatureAuction, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureWonAuction, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMInventoryBoatStorage, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureClimateControl, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureCoveredVehicle, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMMoveDollies, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureDriveUp, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMInventoryIndoorVehicleStorage, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureLights, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureMaintenancePest, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureMobileApp, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureMovingServices, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMMoveMovingTruck, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureOutdoorParking, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMMoveSupplies, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeaturePropane, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMInventoryRVParking, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureRVCovered, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureRVEnclosed, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureSecurity, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMInventoryVehicleStorage, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMFeatureWine, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1") },
  { key: LocationVarKey.LLMIssueBilling, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1") },
  { key: LocationVarKey.LLMIssueDamagedItems, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1") },
  { key: LocationVarKey.LLMIssueEmergency, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1") },
  { key: LocationVarKey.LLMIssueGetOut, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1") },
  { key: LocationVarKey.LLMIssueLostKey, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1") },
  { key: LocationVarKey.LLMIssueTheft, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1") },
  { key: LocationVarKey.LLMIssueWeb, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1") },
  { key: LocationVarKey.LLMLeaseCancellation, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseClaim, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseContractLengths, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseCovid, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseCutLocks, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseFacilityAccess, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMPurchaseIdentification, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseInsurance, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseLiveInUnit, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMPurchaseMonthly, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseMoveOutPolicy, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseOverlock, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMPurchasePayOnline, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMPurchaseOptions, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeasePricing, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseProrate, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseRefunds, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseStorableItems, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseUnitTransfer, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMMoveVehicleStorageGuidelines, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMLeaseWorkInUnit, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1") },
  { key: LocationVarKey.LLMPricingAdminFee, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1") },
  { key: LocationVarKey.LLMPricingCreditCardFee, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1") },
  { key: LocationVarKey.LLMPricingInsurance, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1") },
  { key: LocationVarKey.LLMPricingLateFee, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1") },
  { key: LocationVarKey.LLMPricingRateIncrease, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1") },
  { key: LocationVarKey.LLMPricingReferral, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1") },
  { key: LocationVarKey.LLMPricingVBP, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1") },
  { key: LocationVarKey.LLMPricingWebRate, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1") },
  { key: LocationVarKey.LLMFeatureCeiling, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisSizing, "1") },
  { key: LocationVarKey.LLMInventoryPOMailbox, hideIf: IS_NOT_EQUAL(LocationVarKey.LLMisSizing, "1") },
  LocationVarKey.VoiceAccountBalanceHasLLM,
  LocationVarKey.VoiceAccountNumberHasLLM,
  LocationVarKey.VoiceAutopayHasLLM,
  LocationVarKey.VoiceCancelHasLLM,
  LocationVarKey.VoiceEditAccountInfoHasLLM,
  LocationVarKey.VoiceGateCodeHasLLM,
  LocationVarKey.VoiceGetLeaseHasLLM,
  LocationVarKey.VoiceLoginIssuesHasLLM,
  LocationVarKey.VoiceManageInsuranceHasLLM,
  LocationVarKey.VoicePayBillHasLLM,
  LocationVarKey.VoicePaymentHistoryHasLLM,
  LocationVarKey.VoiceShowInventoryHasLLM
];

export default function LocationSubpageHours() {
  const page = usePropertiesGetLocationIds();

  return (
    <>
      <SectionHeader {...page}> Subscription Information </SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.OnboardingDocument} label="Onboarding Document" />
          <DropdownRow
            {...page}
            label="Tier"
            keyName={LocationVarKey.whichTier}
            options={[
              {
                label: "Engage",
                value: "Engage"
              },
              {
                label: "Foundation",
                value: "Foundation"
              },
              {
                label: "Innovator",
                value: "Innovator"
              },
              {
                label: "Disruptor",
                value: "Disruptor"
              }
            ]}
          />
          <InputRow {...page} keyName={LocationVarKey.SubscriptionMaxUsers} label="Max Users" />
          <SwitchRow {...page} keyName={LocationVarKey.AgentAssistEnabled} label="Agent Assist" />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.SubscriptionEscalationSummary} label="Escalation History" />
          <SwitchRow {...page} keyName={LocationVarKey.HasReviewManager} label="Review Manager" />
          <SwitchRow {...page} keyName={LocationVarKey.HasSMSCampaigns} label="SMS Campaigns" />
          <SwitchRow {...page} keyName={LocationVarKey.swivlHasVoice} label="Voice" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Organization Settings </SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          {/* <SwitchRow {...page} keyName={LocationVarKey.FMSSyncEnabled} label="FMS Sync Enabled" /> */}
          <InputRow {...page} keyName={LocationVarKey.S3AnalyticsDir} label="S3 Analytics Directory" />
          <InputRow {...page} keyName={LocationVarKey.SpotBrandSlug} label="Spot Brand Slug" />
          <InputRow {...page} keyName={LocationVarKey.BrandImage} label="Brand Image" />
          <InputRow {...page} keyName={LocationVarKey.BrandColor} label="Brand Color" />
        </WorksheetColumn>
        <WorksheetColumn>
          <DropdownRow
            {...page}
            marginTop
            label=" Persona"
            keyName={LocationVarKey.Persona}
            options={[
              {
                label: "Self Storage",
                value: "Self Storage"
              },
              {
                label: "RV Boat",
                value: "RV Boat"
              }
            ]}
          />
          <DropdownRow
            {...page}
            marginTop
            label=" Website Provider"
            keyName={LocationVarKey.WebsiteProvider}
            options={[
              {
                label: "None",
                value: "none"
              },
              {
                label: "GoLocal",
                value: "golocal"
              },
              {
                label: "G5",
                value: "g5"
              },
              {
                label: "StoragePug",
                value: "storagepug"
              },
              {
                label: "StorEdge",
                value: "storedge"
              },
              {
                label: "Mariposa",
                value: "mariposa"
              },
              {
                label: "Automatit",
                value: "automatit"
              },
              {
                label: "Storagely",
                value: "storagely"
              },
              {
                label: "Cubby",
                value: "cubby"
              }
            ]}
          />
          <InputRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.WebsiteProvider, "storagely")}
            keyName={LocationVarKey.StoragelyClientID}
            label="Storagely Client ID"
          />
          <InputRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.WebsiteProvider, "storagepug")}
            keyName={LocationVarKey.StoragePugSingleLocationBaseURL}
            label="StoragePug Single Location URL (everything before /view-unit...)"
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Organization Settings (less common) </SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <DropdownRow
            {...page}
            label="Notification for Every Chat"
            marginTop
            keyName={LocationVarKey.WantsNewChatNotifications}
            options={[
              { label: "No", value: "0" },
              { label: "Email only", value: "email" },
              { label: "SMS only", value: "sms" },
              { label: "Both", value: "both" }
            ]}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LeadEnableDuplicates} label="Enable Duplicate Leads" />
          <SwitchRow {...page} keyName={LocationVarKey.TwoUnhandledBeforeEscalation} label="Two Unhandled Before Escalation" />
          <SwitchRow {...page} keyName={LocationVarKey.WantsProfanityEscalation} label="Escalate on Profanity" />
          <SwitchRow {...page} keyName={LocationVarKey.HasSingleLocation} label="Single Location Operator" />
          <SwitchRow {...page} keyName={LocationVarKey.WantsOneMenuView} label="One Menu View" />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.WantsClearStoreVariables} label="Clear Store Variables on Welcome Back" />
          <SwitchRow {...page} keyName={LocationVarKey.ShowSizeDescriptions} label="Show Size Descriptions Worksheet" />
          <SwitchRow {...page} keyName={LocationVarKey.dontUseURLToSetStore} label="Do Not Use URL to Set Facility ID" />
          <SwitchRow {...page} keyName={LocationVarKey.VarySettings} label="Variables Used in Company Information or Important URLs" />
          <Indent {...page}>
            <SwitchRow
              {...page}
              keyName={LocationVarKey.VariesLoginURL}
              label="Account Login URL"
              hideIf={IS_NOT_EQUAL(LocationVarKey.VarySettings, "1")}
            />
            <SwitchRow
              {...page}
              keyName={LocationVarKey.VariesPayOnlineURL}
              label="Pay Online URL"
              hideIf={IS_NOT_EQUAL(LocationVarKey.VarySettings, "1")}
            />
            <SwitchRow
              {...page}
              keyName={LocationVarKey.VariesSizeVisualsURL}
              label="Size Visuals URL"
              hideIf={IS_NOT_EQUAL(LocationVarKey.VarySettings, "1")}
            />
          </Indent>
          <InputRow {...page} keyName={LocationVarKey.LeadUnitId} label="Lead Unit" />
          <InputRow {...page} keyName={LocationVarKey.OnlyShowUnitDimensions} label="Only Show Unit Dimensions" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Getting Started</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.GSGettingStartedCompleted} label="Getting Started Completed" />
          <SwitchRow {...page} keyName={LocationVarKey.GSKickOffMilestoneCompleted} label="Kick Off Tasks Completed" />
          <SwitchRow {...page} keyName={LocationVarKey.GSMilestone1Completed} label="Milestone 1 Tasks Completed" />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.GSMilestone2Completed} label="Milestone 2 Tasks Completed" />
          <SwitchRow {...page} keyName={LocationVarKey.GSPostLaunchCompleted} label="Post-Launch Tasks Completed" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> In-Chat After Navigate Quest Slugs</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <QuestDropdownRow {...page} keyName={LocationVarKey.AfterNavigateSizeVisualsQuestSlug} label="Size Visuals Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateShowInventoryQuestSlug} label="Show Inventory Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginAutopayQuestSlug} label="Auto Pay Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginPayBillQuestSlug} label="Pay Bill Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginPasswordQuestSlug} label="Password Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginUsernameQuestSlug} label="Username Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginCreateLoginQuestSlug} label="Create Login Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginCreditDebitQuestSlug} label="CreditDebit Quest Slug" />
        </WorksheetColumn>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginReservationsQuestSlug} label="Reservations Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginUpdateBillingQuestSlug} label="Update Billing Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginUpdateContactQuestSlug} label="Update Contact Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateCareersQuestSlug} label="Career Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateInsuranceQuestSlug} label="Insurance Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAuctionQuestSlug} label="Auction Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateReferralQuestSlug} label="Referral Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginCancelServiceQuestSlug} label="Cancel Service Quest Slug" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> SMS After Navigate Quest Slugs</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSShowInventoryQuestSlug} label="SMS Show Inventory Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSPayBillQuestSlug} label="SMS Pay Bill Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAuctionQuestSlug} label="SMS Auction Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSSizeVisualsQuestSlug} label="SMS Size Visuals Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSReferralQuestSlug} label="SMS Referral Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSCareerQuestSlug} label="SMS Career Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSInsuranceQuestSlug} label="SMS Insurance Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAboutQuestSlug} label="SMS About Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSCreditDebitQuestSlug} label="SMS CreditDebit Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAutoPayQuestSlug} label="SMS Auto Pay Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSPasswordQuestSlug} label="SMS Password Quest Slug" />
        </WorksheetColumn>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSUpdateBillingQuestSlug} label="SMS Update Billing Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSCreateLoginQuestSlug} label="SMS Create Login Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSUsernameQuestSlug} label="SMS Username Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSReservationsQuestSlug} label="SMS Reservations Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAccountPayBillQuestSlug} label="SMS Account - Pay Bill Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSUpdateContactQuestSlug} label="SMS Update Contact Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAccountLoginQuestSlug} label="SMS Account Login Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSSelectStoreQuestSlug} label="SMS SELECT Store Quest Slug" />
          <InputRow
            {...page}
            keyName={LocationVarKey.AfterNavigateSMSAccountLoginCancelServiceQuestSlug}
            label="SMS Account - Cancel Service Quest Slug"
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Spot After Navigate Quest Slugs</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.SpotAccessCodeQuestSlug} label="Intent: Get Help Access Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.SpotReviewQuestSlug} label="Intent: Give Feedback Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.SpotPayBillOnlineQuestSlug} label="URL: Online Bill Pay Quest Slug" />
        </WorksheetColumn>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.SpotPayBillPhoneQuestSlug} label="SF: Pay By Phone Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.SpotManageAccountQuestSlug} label="Intent: Manage Account Quest Slug" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - LLM Agent Settings</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.LLMAIStorageConsultant} label="AI Storage Consultant (Sales)" />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.LLMAICustomerSupportRep} label="AI Customer Support Rep" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - Category Settings</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.LLMisSizing} label="Making Size Recommendations" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMisStoreSpecific} label="Store-Specific Information" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMisUnhandled} label="Unhandled Questions" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMisSuggestingPostalCode} label="Suggesting Postal Codes" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMisAccess} label="Access Related Interactions" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMisAccountManagement} label="Account Related Questions" />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.LLMisFeatures} label="Feature Related Questions" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMisIssueResolution} label="Issue Resolution" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMisLease} label="Lease Term Inquiries" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMisPricing} label="Pricing Related Questions" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMisInventory} label="Show Inventory" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMHasABTestAgents} label="A/B Test Agents" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - Access</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccessAfterHours}
            label="After Hours"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMAccessGateCode} label="Gate Code" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1")} />
          <SwitchRow {...page} keyName={LocationVarKey.LLMAccessKey} label="Key Access" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccessPadlock}
            label="Padlock / DaVinci"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1")}
          />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.LLMMoveTour} label="Tour" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccessUnitNumber}
            label="Unit Number"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccessAccountPastDue}
            label="Account Past Due"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccessAccountInactive}
            label="Account Inactive"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccess, "1")}
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - Account Management</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountAccountBalance}
            label="Account Balance"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountAccountNumber}
            label="Account Number"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountAutopay}
            label="Autopay"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountBillingDispute}
            label="Billing Dispute"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountCancelService}
            label="Cancel Service"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountChangeDueDate}
            label="Due Date"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountCreateLogin}
            label="Create Login"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountForgotUsername}
            label="Forgot Username"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountGetLease}
            label="Get Lease"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountGracePeriod}
            label="Grace Period"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountHoldUnit}
            label="Hold Unit"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountManageInsurance}
            label="Manage Insurance"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountMultipleAccounts}
            label="Multiple Accounts"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountPartialPayment}
            label="Partial Payment"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountPastDue}
            label="Past Due"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountPayBill}
            label="Pay Bill"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountPaymentExtension}
            label="Payment Extension"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountPaymentHistory}
            label="Payment History"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountPaymentIssue}
            label="Payment Issue"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountReservations}
            label="Reservation"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountResetPassword}
            label="Reset Password"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountUnitSize}
            label="Unit Size"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountUpdateBillingInfo}
            label="Update Billing Info"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMAccountUpdateContactInfo}
            label="Update Contact Info"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement, "1")}
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - Features &amp; Amenities</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.LLMFeatureAuction} label="Auctions" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureWonAuction}
            label="Auction Winners"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMInventoryBoatStorage}
            label="Boat Storage"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureClimateControl}
            label="Climate Control"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureCoveredVehicle}
            label="Covered Vehicle Storage"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMMoveDollies} label="Dollies" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureDriveUp}
            label="Drive-Up Units"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMInventoryIndoorVehicleStorage}
            label="Indoor Vehicle Storage"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMFeatureLights} label="Lights" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureMaintenancePest}
            label="Maintenance/Pests"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureMobileApp}
            label="Mobile App"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureMovingServices}
            label="Moving Services"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMMoveMovingTruck}
            label="Moving Truck"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureOutdoorParking}
            label="Outdoor Parking"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMMoveSupplies}
            label="Packing Supplies"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMFeaturePropane} label="Propane" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMInventoryRVParking}
            label="RV Parking"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureRVCovered}
            label="RV Parking Covered"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureRVEnclosed}
            label="RV Parking Enclosed"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureSecurity}
            label="Security"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMInventoryVehicleStorage}
            label="Vehicle Storage"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureWine}
            label="Wine Storage"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisFeatures, "1")}
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - Issue Resolution</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMIssueBilling}
            label="Billing Issue"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMIssueDamagedItems}
            label="Damaged Items"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMIssueEmergency}
            label="Emergency"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMIssueGetOut}
            label="Get Out"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1")}
          />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMIssueLostKey}
            label="Lost Key"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMIssueTheft} label="Theft" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMIssueWeb}
            label="Web Issues"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisIssueResolution, "1")}
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - Lease</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMLeaseCancellation}
            label="Cancellation"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMLeaseClaim} label="File A Claim" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMLeaseContractLengths}
            label="Contract Lengths"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMLeaseCovid} label="Covid" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")} />
          <SwitchRow {...page} keyName={LocationVarKey.LLMLeaseCutLocks} label="Cut Locks" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMLeaseFacilityAccess}
            label="Facility Access"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMPurchaseIdentification}
            label="Identification"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMLeaseInsurance} label="Insurance" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMLeaseLiveInUnit}
            label="Live In Unit"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMPurchaseMonthly}
            label="Monthly Pricing"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMLeaseMoveOutPolicy}
            label="Move Out Policy"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.LLMLeaseOverlock} label="Overlock" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMPurchasePayOnline}
            label="Pay Online"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMPurchaseOptions}
            label="Payment Options"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMLeasePricing} label="Pricing" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")} />
          <SwitchRow {...page} keyName={LocationVarKey.LLMLeaseProrate} label="Prorate" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")} />
          <SwitchRow {...page} keyName={LocationVarKey.LLMLeaseRefunds} label="Refunds" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMLeaseStorableItems}
            label="Storable Items"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMLeaseUnitTransfer}
            label="Unit Transfer"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMMoveVehicleStorageGuidelines}
            label="Storage Guidelines"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMLeaseWorkInUnit}
            label="Work In Unit"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisLease, "1")}
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - Pricing</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMPricingAdminFee}
            label="Admin Fee"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMPricingCreditCardFee}
            label="Credit Card Fee"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1")}
          />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMPricingInsurance}
            label="Insurance Cost"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMPricingLateFee} label="Late Fee" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1")} />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMPricingRateIncrease}
            label="Rate Increase"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMPricingReferral} label="Referral" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1")} />
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMPricingVBP}
            label="Value Based Pricing"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1")}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LLMPricingWebRate} label="Web Rates" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1")} />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - Sizing</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMFeatureCeiling}
            label="Ceiling Height"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisSizing, "1")}
          />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.LLMInventoryPOMailbox}
            label="PO / Mail Boxes"
            hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisSizing, "1")}
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Enhance with AI - Voice</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.VoiceAccountBalanceHasLLM} label="Account Balance" />
          <SwitchRow {...page} keyName={LocationVarKey.VoiceAccountNumberHasLLM} label="Account Number" />
          <SwitchRow {...page} keyName={LocationVarKey.VoiceAutopayHasLLM} label="Autopay" />
          <SwitchRow {...page} keyName={LocationVarKey.VoiceCancelHasLLM} label="Cancel" />
          <SwitchRow {...page} keyName={LocationVarKey.VoiceEditAccountInfoHasLLM} label="Update Account Info" />
          <SwitchRow {...page} keyName={LocationVarKey.VoiceGateCodeHasLLM} label="Gate Code" />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.VoiceGetLeaseHasLLM} label="Get Lease" />
          <SwitchRow {...page} keyName={LocationVarKey.VoiceLoginIssuesHasLLM} label="Login Issues" />
          <SwitchRow {...page} keyName={LocationVarKey.VoiceManageInsuranceHasLLM} label="Manage Insurance" />
          <SwitchRow {...page} keyName={LocationVarKey.VoicePayBillHasLLM} label="Pay Bill" />
          <SwitchRow {...page} keyName={LocationVarKey.VoicePaymentHistoryHasLLM} label="Payment History" />
          <SwitchRow {...page} keyName={LocationVarKey.VoiceShowInventoryHasLLM} label="Rent a Unit" />
        </WorksheetColumn>
      </WorksheetRow>
    </>
  );
}
